"use strict";
// do not expose this model outside of payment form, only used within the payment iframe component
var PaymentDataResponse = (function () {
    function PaymentDataResponse() {
    }
    return PaymentDataResponse;
}());
exports.PaymentDataResponse = PaymentDataResponse;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/payments/payment-data-response.model.js